import React from 'react';
import { Box, Switch as SwitchMUI, Typography } from '@mui/material';

export function Switch({ label, checked, handleChange }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        '.MuiSwitch-root': {
          padding: '8px',
        },
        '.MuiButtonBase-root.Mui-checked + .MuiSwitch-track': {
          backgroundColor: 'grey.200',
        },
        '.MuiSwitch-track': {
          borderRadius: '99px',
          backgroundColor: 'grey.200',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'grey.500',
        },
        '.MuiButtonBase-root .MuiSwitch-thumb': {
          backgroundColor: 'grey.300',
        },
        '.MuiButtonBase-root.Mui-checked .MuiSwitch-thumb': {
          backgroundColor: 'switch.thumb',
        },
      }}
    >
      {label ? (
        <Typography sx={{ marginTop: '5px', lineHeight: '0.4rem' }}>
          {label}
        </Typography>
      ) : null}
      <SwitchMUI checked={checked} onChange={handleChange} />
    </Box>
  );
}
